import { render } from "./RecommendedQuestion.vue?vue&type=template&id=ce7da4b8&scoped=true"
import script from "./RecommendedQuestion.vue?vue&type=script&lang=js"
export * from "./RecommendedQuestion.vue?vue&type=script&lang=js"

import "./RecommendedQuestion.vue?vue&type=style&index=0&id=ce7da4b8&lang=scss&scoped=true"

import exportComponent from "/Users/stepanmaksimov/Documents/Claude/Projects/A.sk/answerio-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce7da4b8"]])

export default __exports__